module.exports = __webpack_public_path__ + "img/blog-4.92f3e6d2.webp";